import React from 'react'
import './Navbar.css'
import production from '../../images/production.png'
import portal from '../../images/portal.png'
import setting from '../../images/setting.png'
import { Link } from 'react-router-dom'
import tes from "../../images/test-manager.png"
const TracerNavbar = ({isActive}) => {
  
  return (
    <>
    <div className= "nav d-flex justify-content-between">
        <div className={isActive ? "left d-flex align-items-center left-ac" : "left d-flex align-items-center " }>
        <div className="lg">
            <div className="mini-head">Active Panel #91857   04:09</div>
            <div className="lg-head" >Tracer NanoRX/ Top</div>
        </div>
        <div className="lg lg2" >
            <div className="mini-head">Fumax Old Batch / 3  00:41</div>
            <div className="lg-head">Serial# 342006</div>
        </div>
        </div>
        <ul className={isActive ? "ul-active navactive" : null}>
        <li> <Link to="/trs"><img src={production} alt="" /> Production Jigs</Link></li>
            <li> <Link to="/portalCTQ"><img src={portal} alt="" /> Portals</Link> </li>
            <li> <Link to="/Configration"><img src={setting} alt="" />Stock Manager</Link> </li>
            <li> <Link to="/account"><img src={tes} alt="" />Account</Link> </li>
        </ul>
    </div>
   
    </>
  )
}

export default TracerNavbar;